import React, { useState, useEffect } from "react";
import "../../styles/urai.css";

const Urai = () => {
  const [activeTab, setActiveTab] = useState("quotes");
  const [expandedImage, setExpandedImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [famousPerson, setFamousPerson] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/famous.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        if (data.famousPerson) {
          setFamousPerson(data.famousPerson);

        } else {
          throw new Error("portfolioData not found in response");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const openImageModal = (image) => {
    setExpandedImage(image);
  };

  const closeImageModal = () => {
    setExpandedImage(null);
  };

  return (
    <div className="famous-person-app">
      <nav className="content-tabs">
        <button
          className={activeTab === "quotes" ? "active" : ""}
          onClick={() => setActiveTab("quotes")}
        >
          Famous Quotes
        </button>
        <button
          className={activeTab === "gallery" ? "active" : ""}
          onClick={() => setActiveTab("gallery")}
        >
          Photo Gallery
        </button>
      </nav>

      <main className="content-container">
        {/* <h1 className="publication-title"></h1> */}
        {activeTab === "quotes" && (
          <div className="quotes-section">
            {famousPerson.quotes.map((quote, index) => (
              <div key={index} className="quote-card">
                <div
                  className="quote-image-container"
                  onClick={() => openImageModal(quote.image)}
                >
                  <img
                    src={quote.image}
                    alt={`${famousPerson.name} - ${quote.source}`}
                    className="quote-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://via.placeholder.com/600x400?text=Image+Not+Available";
                    }}
                  />
                  <div className="image-hover-effect">
                    <span className="zoom-icon">🔍</span>
                  </div>
                </div>
                <div className="quote-content">
                  <blockquote className="quote-text">"{quote.text}"</blockquote>
                  <div className="quote-meta">
                    <cite className="quote-source">{quote.source}</cite>
                    <div className="quote-details">
                      <span className="quote-date">{quote.date}</span>
                      <span className="quote-location">{quote.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === "timeline" && (
          <div className="timeline-section">
            <div className="timeline-line"></div>
            {famousPerson.timeline.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-year">{item.year}</div>
                <div className="timeline-event">{item.event}</div>
              </div>
            ))}
          </div>
        )}

        {activeTab === "gallery" && (
          <div className="gallery-section">
            {famousPerson.gallery.map((item, index) => (
              <div
                key={index}
                className="gallery-item"
                onClick={() => openImageModal(item.image)}
              >
                <img
                  src={item.image}
                  alt={item.caption}
                  className="gallery-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://via.placeholder.com/600x400?text=Image+Not+Available";
                  }}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        )}
      </main>

      {expandedImage && (
        <div className="image-modal1" onClick={closeImageModal}>
          <div className="modal-content1">
            <button className="close-modal" onClick={closeImageModal}>
              ×
            </button>
            <img
              src={expandedImage}
              alt="Expanded view"
              className="expanded-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Urai;
